import { createTheme } from '@mui/material/styles';

import { baseTheme, getCommonThemesProps } from './baseTheme';
import { standardColors } from './colors';

export const themeStandard = () => {
  const theme = baseTheme();

  const themeProperties = getCommonThemesProps(standardColors);
  const { palette, components } = themeProperties;

  return createTheme({
    breakpoints: theme.breakpoints,
    palette,
    components,
    customLogo: {
      logo: 'STANDARD_LOGO',
      slogo: 'STANDARD_SLOGO',
      nlogo: 'STANDARD_NLOGO',
      clogo: 'STANDARD_CLOGO',
    },
    verticalBreakpoints: theme.verticalBreakpoints,
    typography: {
      fontFamily: [
        'Benton Sans Pro',
        'Roboto',
        'Roboto Mono',
        'Arial',
        'sans-serif',
      ].join(),
    },
  });
};

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV !== 'production') {
  window.theme = themeStandard();
}
